import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

export const BUSINESS = {
  name: "Platinum Auto And Home",
  short: "Platinum",
  phone: "406-213-6881",
  phoneHref: "tel:+14062136881",
  emailAuto: "Auto@platinumautoandhome.com",
  emailHome: "Home@platinumautoandhome.com",
  location: "Bozeman, Montana",
};

export const api = axios.create({ baseURL: API });

// Attach admin JWT if present
api.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const t = localStorage.getItem("padmin_token");
    if (t && config.url && config.url.includes("/admin")) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});
